(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('BrandSearchFrom');
    const searchInput = document.getElementById('brandSearchInput');
    const collectionList = document.querySelectorAll('.section-collection-list');
    const brandList = document.querySelectorAll('.custom-collection-brand-list');
    const brandTitle = document.querySelectorAll('.custom-collections-brand-title');
    const brandLetters = document.querySelector('.custom-collection-brand-letters');
    const brandWrappers = document.querySelector('.custom-collection-brand-list-wrapper');
    const searchReset = document.querySelector('.brand-search-reset');
    
  
    function getCollectionItems() {
      const items = [];
      collectionList.forEach(element => {
        const searchTerms = element.getAttribute('data-search');
        if (searchTerms) {
          items.push({
            element: element,
            searchTerms: searchTerms.toLowerCase()
          });
        }
      });
      return items;
    }
  
    function hideCollectionTitle() {
      brandLetters.style.display = 'none';
      brandWrappers.classList.add('found');
      brandTitle.forEach(title => {
        title.style.display = 'none';
      });
      searchReset.classList.add('show');
    }
    function showCollectionTitle() {
      brandLetters.style.display = '';
      brandWrappers.classList.remove('found');
      brandTitle.forEach(title => {
        title.style.display = '';
      });
      collectionList.forEach(list => {
        list.style.display = '';
      });
      brandList.forEach(list => {
        list.classList.remove('hide'); 
        list.classList.remove('found'); 
      });
      searchReset.classList.remove('show');
    }
  
    function filterAndHighlight(searchTerm) {
      const items = getCollectionItems();
      const lowerSearchTerm = searchTerm.toLowerCase();
      
      const matchesItem = [];
      items.forEach(item => {
        const matches = item.searchTerms.includes(lowerSearchTerm);        
        const listContainer = item.element.closest('.custom-collection-brand-list');
        listContainer.classList.add('hide'); 
        if(matches) { 
          matchesItem.push({
            element: item.element
          });
        }
        item.element.style.display = matches ? '' : 'none';
      });
      
      hideCollectionTitle();  
      if(matchesItem.length > 0) {      
        matchesItem.forEach(item => {
          const listContainer = item.element.closest('.custom-collection-brand-list');
          listContainer.classList.remove('hide'); 
          listContainer.classList.add('found'); 
        });
      }
    }
  
    searchInput.addEventListener('input', function(e) {
      const searchTerm = e.target.value;
      showCollectionTitle();
      if (searchTerm) {
        filterAndHighlight(searchTerm);
        searchReset.classList.add('show');
      }
    });
  
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const searchTerm = searchInput.value;
      showCollectionTitle();
      if (searchTerm) {
        filterAndHighlight(searchTerm);
        searchReset.classList.add('show');
      }
    });
  
    form.addEventListener('reset', function(e) {
      e.preventDefault();
      showCollectionTitle();
      searchReset.classList.remove('show');
      searchInput.value = "";
    });
  
    function clearLetter() {
      const letters = brandLetters.querySelectorAll('.alphabetical-filter li.not-empty a');
      letters.forEach(letter => {
        letter.classList.remove('active');
      });      
    }

    const letters = brandLetters.querySelectorAll('.alphabetical-filter li.not-empty a');
    letters.forEach(letter => {
      letter.addEventListener('click', function(e) {
        clearLetter();
        this.classList.add('active');
      });
    });
  });  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-personal"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {    
    const close = document.querySelector('.success-account img.close');  
    if(close) {
      close.addEventListener('click', (e) => {
        e.preventDefault();
        e.target.parentElement.classList.add('hide');
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        searchParams.delete('success');
        url.search = searchParams.toString();
        history.pushState({}, '', url.toString());
      });      
    }
  });  
  var formId = 'r9tOb1';
  var $form = document.querySelector('form[data-cf-form="' + formId + '"]');

  document.addEventListener('cf:ready', function() {
    const myInput = $form.querySelector('input[name="birthday"]');
    const inputId = myInput.getAttribute('id');
    const desc = document.getElementById(inputId+'description');

    let inputString = myInput.value;
    let filteredString = inputString.replace(/-/g, ""); // The 'g' flag ensures all hyphens are replaced
    let length = filteredString.length;
    
    let div = document.createElement("div");
    div.id = 'count_input';
    div.textContent = length+'/8';
    desc.appendChild(div);

    myInput.addEventListener('input', function() {
      const count_div = document.getElementById('count_input');
      let inputString = myInput.value;
      let filteredString = inputString.replace(/-/g, ""); // The 'g' flag ensures all hyphens are replaced
      let length = filteredString.length;
      if(length > 8) {length = 8}
      count_div.textContent = length+"/8";
    });

    $form.addEventListener('cf:field_changed', function(event) {
      document.querySelector('.cf-submit-form').classList.add('changing');

      if(event.detail.columnKey == 'birthday') {
        const myInput = document.querySelector('input[name="birthday"]');
        const inputId = myInput.getAttribute('id');
        const desc = document.getElementById(inputId+'description');
        const count_div = document.getElementById('count_input');

        let inputString = myInput.value;
        let filteredString = inputString.replace(/-/g, ""); // The 'g' flag ensures all hyphens are replaced
        let length = filteredString.length;
        if(length > 8) {length = 8}
        count_div.textContent = length+"/8";
      }
    });
    
    document.querySelector('.cf-country-flag-emoji').innerHTML = "<img src='https://flagcdn.com/20x15/ph.png'>";
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
